<template>
  <button
    class="btn pmd-btn-fab btn-fab pmd-ripple-effect btn-success"
    type="button"
    @click="openWhatsapp"
    v-if="phoneNumber"
  >
    <i class="fab fa-whatsapp"></i>
  </button>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters([
      "phoneNumber",
    ])
  },
  methods: {
    openWhatsapp() {
      window.location.href = `https://wa.me/${this.phoneNumber}`
    },
  }
};
</script>

<style lang="scss" scoped>
.btn-fab { 
  position: fixed; 
  bottom: 15px; 
  left: 15px;
  border-radius: 100%;
  z-index: 999;
}
</style>
